import { render, staticRenderFns } from "./PartnerFormPage.vue?vue&type=template&id=3904d922&"
import script from "./PartnerFormPage.vue?vue&type=script&lang=js&"
export * from "./PartnerFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports